/**
 * Feature flags toggled by hand in the browser console, for staged rollouts:
 *
 *     localStorage.setItem("waypoint:newICReport", "true")
 *
 * There is no UI for these on purpose — they are for us, not for clients.
 */
export const FEATURE_FLAGS = {
    /** Generate the IC report in the browser from the corrected roll-up, rather than on the server. */
    newICReport: "waypoint:newICReport",
} as const;

export function isFeatureEnabled(flag: (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]): boolean {
    try {
        return localStorage.getItem(flag) === "true";
    } catch {
        // private browsing and similar can throw on access
        return false;
    }
}
